import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstimateForm = _resolveComponent("EstimateForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_EstimateForm, {
      estimate: _ctx.estimate,
      "segment-configurations-factory": _ctx.createSegmentConfiguration
    }, null, 8, ["estimate", "segment-configurations-factory"])
  ]))
}